import config from "../../../config/config.json";
import { headers } from "../../../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
  cancelPreviousRequest,
  decryptResponse
} from "../../../APIHelpers/Responses";

export const storeCustomerServices = {
  addNewStoreCustomer,
  updatedStoreCustomer,
  softDeleteRestoreStoreCustomer,
  deleteStoreCustomer,
  getStoreCustomerList,
  getStoreSingleCustomer
};

// Add New Store Customer
async function addNewStoreCustomer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addNewStoreCustomer`,
    headersWithAuth("POST", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Update Store Customer
async function updatedStoreCustomer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updatedStoreCustomer`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Soft Delete & Restore Store Customer
async function softDeleteRestoreStoreCustomer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}softDeleteRestoreStoreCustomer`,
    headersWithAuth("PUT", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Delete Store Customer
async function deleteStoreCustomer(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStoreCustomer`,
    headersWithAuth("DELETE", userData, headers)
  );
  const result = await response.json();
  const data = decryptResponse(result);
  handleResponse(data)
  return data;
}

// Get All Store Customer
async function getStoreCustomerList(status, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreCustomerList`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCustomerList/${status}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreCustomerList/${status}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}

// Get Single Store Customer
async function getStoreSingleCustomer(customerId, search, page, length) {
  try {
    const signal = cancelPreviousRequest(`getStoreSingleCustomer`);
    let apiURL;
    if (page && length) {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleCustomer/${customerId}?search=${search || ""}&page=${page}&length=${length}`;
    } else {
      apiURL = `${config.API_URL_USER_ONBOARDING}getStoreSingleCustomer/${customerId}?search=${search || ""}`;
    }
    const response = await fetch(apiURL, {
      ...headersWithAuthWithoutBody("GET", headers),
      signal
    });
    const result = await response.json();
    const data = decryptResponse(result);
    if (data?.statusCode === 401) {
      handleResponse(data)
    }
    return data;
  } catch (err) {
    if (err.name === "AbortError") {
      return "AbortError";
    }
    throw err;
  }
}